export default __webpack_public_path__ + "static/media/AtomsAndCompounds _06.d304936f.png";